<div class="container-fluid my-4 text-center" style="margin-top:150px;height: 66vh" >
    <h3 style="font-family:Palatino Linotype,Book Antiqua, Palatino, serif;color:rgb(30, 32, 32);font-weight:bold">
        <!-- {{ErrMsg}} -->
      Access Denied
    </h3>
    <h4 style="font-style:italic;color:black"> 
        Please reach out to <a href="mailto: automationjourney_dev@accenture.com">myWizardAJ.Support</a> for access.
    </h4>
</div>